export var errorCodes = {
    invalidScope: 'invalid_scope',
    userDeclined: 'user_declined',
    accessDenied: 'access_denied',
    serverError: 'server_error',
    unhandledError: 'Unhandled error:'
};
export default errorCodes;
